// extracted by mini-css-extract-plugin
module.exports = {"link":"SpecialUrls_link__2M1Os"};